import { Color } from '@altenull/foret-core';
import { css } from '@emotion/core';
import React from 'react';

const linkIconStyles = (size, color) => css`
  display: block;
  width: ${size}px;
  height: ${size}px;
  fill: ${color};
  cursor: pointer;
`;

const LinkIcon = ({ size = 24, color = Color.Ink, ...props }) => {
  return (
    <svg css={linkIconStyles(size, color)} {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 477.4 477.4'>
      <path d='M451.2 68.6c-16.8-16.8-39.6-26.2-63.3-26.2v0c-23.7-0.1-46.5 9.4-63.3 26.2L209.1 184.2c-22.9 22.9-31.6 56.4-22.9 87.5 2.6 9.1 12 14.4 21.1 11.8 9.1-2.6 14.4-12 11.8-21.1 -5.4-19.3 0-39.9 14.1-54.1L348.8 92.8c21.6-21.6 56.6-21.6 78.3 0 21.6 21.6 21.6 56.6 0 78.3L311.5 286.6c-7.6 7.6-17.2 12.8-27.7 15 -9.2 1.9-15.2 11-13.2 20.2 1.7 7.9 8.7 13.6 16.8 13.6 1.2 0 2.4-0.1 3.6-0.4 17-3.6 32.5-12 44.7-24.3l115.6-115.6C486.1 160.2 486.1 103.6 451.2 68.6z' />
      <path d='M290.7 206.1c-2.6-9.1-12-14.4-21.1-11.8s-14.4 12-11.8 21.1c5.4 19.3 0 40-14.1 54.1L128.1 385.1c-21.6 21.6-56.6 21.6-78.3 0 -21.6-21.6-21.6-56.6 0-78.3l115.6-115.6c7.6-7.6 17.2-12.8 27.6-15 9.2-1.8 15.2-10.8 13.4-20.1s-10.8-15.2-20.1-13.4c-0.1 0-0.2 0-0.3 0.1 -17 3.6-32.5 12-44.7 24.3L25.7 282.7c-34.7 35.2-34.2 91.9 1 126.5 34.8 34.3 90.7 34.3 125.6 0l115.6-115.6C290.7 270.8 299.4 237.3 290.7 206.1z' />
    </svg>
  );
};

export default LinkIcon;
